import { Component, OnInit } from '@angular/core';
import { Event, NavigationStart, Router, RouterEvent } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  standalone: false,
})
export class LayoutComponent implements OnInit {

  constructor(private router: Router) {
    router.events.pipe(filter(event => event instanceof NavigationStart))
      .subscribe((event: Event) => {

        // Hubspot code tracking to track every page visit of our customers.
        const _hsq = window['_hsq'] = window['_hsq'] || [];
        _hsq.push(['setPath', { path: (event as RouterEvent).url }]);
        _hsq.push(['trackPageView']);
      });
  }

  ngOnInit(): void {
  }

}
